import { Form, DatePicker } from "antd";

export default function ({ field, disabled, onChange }) {

  return (
    <Form.Item label="First Run" name={[field.name, "firstRun"]}>
      <DatePicker
        showTime={{ format: 'HH:mm' }}
        disabled={disabled}
        value={Form.useWatch([field.name, "firstRun"])}
        onChange={(date) => onChange?.(date, "firstRun")}
      />
    </Form.Item>
  );
};
